import { S_LANG, webStorage } from "./webStorage";
import dateFormatters from "./dateFormatters";

const ERROR_ELEMENTS_SELECTOR = ".show-warning,.checkbox.error";
export const getScreenCentre = (width, height) => {
  const dualScreenLeft = typeof window.screenLeft !== "undefined" ? window.screenLeft : window.screen.left;
  const dualScreenTop = typeof window.screenTop !== "undefined" ? window.screenTop : window.screen.top;
  const innerWidth = window.innerWidth;
  const innerHeight = window.innerHeight;
  const clientWidth = document.documentElement.clientWidth;
  const clientHeight = document.documentElement.clientHeight;

  let screenWidth = 0;
  if (innerWidth) {
    screenWidth = innerWidth;
  } else if (clientWidth) {
    screenWidth = clientWidth;
  } else {
    screenWidth = window.screen.width;
  }

  let screenHeight = 0;
  if (innerHeight) {
    screenHeight = innerHeight;
  } else if (clientHeight) {
    screenHeight = clientHeight;
  } else {
    screenHeight = window.screen.height;
  }

  return {
    left: (screenWidth - width) / 2 + dualScreenLeft,
    top: (screenHeight - height) / 2 + dualScreenTop
  };
};

export const canUseDOM = () => !!(typeof window !== "undefined" && window.document && window.document.createElement);

export const getPageOffset = () => global.window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

export const getElementOffsetY = el => {
  el = el.getBoundingClientRect();
  return el.top + getPageOffset();
};

export const getPageHeight = () => {
  return Math.max(document.documentElement.clientHeight, document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight);
};
export const openModal = id => {
  let elem = document.getElementById("jss-model-id");
  let closeAll = con => {
    let datasourceidElement = con[0].querySelectorAll("[datasourceid]");
    let arr = [];
    arr.forEach.call(datasourceidElement, function (element) {
      element.classList.remove("show-modal");
      element.style.display = "none";
    });
  };
  if (elem) {
    let con = elem.getElementsByClassName("modal-content");
    closeAll(con);
    if (elem.classList.contains("hide-modal")) {
      elem.classList.remove("hide-modal");
      elem.classList.add("show-modal");
      document.body.classList.add("show-modal");
      let el = elem.querySelector("[datasourceid='" + id + "']");
      if (el) {
        el.classList.add("show-modal");
        el.style.display = "";
      }
      if (elem.scrollTo) {
        elem.scrollTo(0, 0);
      } else {
        elem.scrollTop = 0;
        elem.scrollLeft = 0;
      }
    } else if (elem.classList.contains("show-modal")) {
      elem.classList.add("hide-modal");
      elem.classList.remove("show-modal");
      document.body.classList.remove("show-modal");
    }
  }
};
export const format = (date, format) => {
  if (typeof date === "string" || typeof date === "number") {
    date = new Date(date);
  }
  if (isBizNull(date) || !date instanceof Date || date.toString() === "Invalid Date") {
    return null;
  }
  const year = date.getFullYear(),
    month = date.getMonth() + 1,
    day = date.getDate(),
    hour = date.getHours(),
    minute = date.getMinutes(),
    second = date.getSeconds();
  const o = {
    yyyy: year,
    MM: num.padding(month, 2),
    dd: num.padding(day, 2),
    HH: num.padding(hour, 2),
    mm: num.padding(minute, 2),
    ss: num.padding(second, 2)
  };
  return format.replace(/yyyy|MM|dd|HH|mm|ss/g, match => {
    return o[match];
  });
};
export const getLocalDateFormatter = () => {
  const lang = webStorage.get(S_LANG);
  let formatter = dateFormatters.find(x => x.lang.test(lang));
  if (!formatter) {
    formatter = dateFormatters[0];
  }
  return formatter;
};
export const formatLocalDate = dateValue => {
  if (canUseDOM() && !isBizNull(dateValue)) {
    const formatter = getLocalDateFormatter();
    const date = new Date(dateValue);
    return format(date, formatter.format);
  } else {
    return null;
  }
};
export const num = {
  padding(num, length) {
    const str = num.toString();
    return (Math.pow(10, length) + num).toString().substr(str.length > length ? 0 : 1);
  }
};
export const injectScript = (src, prediction) => {
  return new Promise((resolve, reject) => {
    if (prediction && prediction()) {
      resolve();
    } else {
      const sc = document.createElement("script");
      sc.async = true;
      sc.src = src;
      // sc.crossOrigin = "anonymous";
      sc.addEventListener("load", resolve);
      sc.addEventListener("error", reject);
      document.querySelector("head").appendChild(sc);
    }
  });
};
export const formatString = (str, data) => {
  const result = str.replace(/{[\w\d-_]+?}/gi, match => {
    return data[match.replace(/[{}]/gi, "")];
  });
  return result;
};
export const isBizNull = data => {
  return data === null || data === undefined || data === "";
};
export const scrollToErrorElement = element => {
  if (element) {
    const doScroll = element.getBoundingClientRect().top > 0 && element.getBoundingClientRect().top < window.screen.availHeight ? false : true;
    if (doScroll) {
      const firstErrorInput = document.querySelector(ERROR_ELEMENTS_SELECTOR);
      if (firstErrorInput) {
        const parentForm = firstErrorInput.closest("form");
        if (parentForm) {
          const buttonElement = parentForm.querySelector("button");
          buttonElement &&
            buttonElement.addEventListener("click", function () {
              const _firstErrorInput = document.querySelector(ERROR_ELEMENTS_SELECTOR);
              scrollToErrorElement(_firstErrorInput);
            });
        }
        window.scrollTo({
          top: document.documentElement.scrollTop + firstErrorInput.getBoundingClientRect().top - 100,
          behavior: "smooth"
        });
      }
    }
  }
};
export const downloadFile = (url, title) => {
  const a = document.createElement("a");
  a.download = title || "file";
  a.target = "_blank";
  a.href = url;
  a.click();
};
export const loadImage = src => {
  const img = new Image();
  img.src = src;
  img.crossOrigin = "Anonymous";
  return new Promise((resolve, reject) => {
    img.onload = () => {
      resolve();
    };
    img.onerror = ex => {
      reject(ex);
    };
  });
};
export const lockScreen = () => {
  document.querySelector("html").style.overflow = "hidden";
};
export const screenRelease = () => {
  document.querySelector("html").style.overflow = "visible";
}
export const gtag = function () {
  window.dataLayer.push(arguments);
}
export const preloadSth = (url, mimeType, as) => {
  const el = document.createElement("LINK");
  el.rel = "preload";
  el.href = url;
  el.as = as;
  document.head.appendChild(el);
}

export const injectGTM = (gtmIds) => {
  var jsCode = gtmIds?.map(gtmId => `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtmId}');`).join("\n");
  if (jsCode) {
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.innerHTML = jsCode;
    const target = document.getElementById("gtm-dataLayer");
    if (target && target.parentNode) {
      target.parentNode.insertBefore(script, target.nextSibling);
    } else {
      document.head.appendChild(script);
    }
  }

  const insertScript  = gtmIds?.forEach(gtmId => {
    let noscript = document.createElement("noscript");
    let iframe = document.createElement("iframe");
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    iframe.width = "0";
    iframe.height = "0";
    iframe.style = "display:none;visibility:hidden";
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
  });
}